module.exports = __webpack_public_path__ + "media/images/brunet-hover-2ef85930e25c42a16bc20d1fdc303754.jpg";